import { HTTP } from '@/utilities/http-common';

export default {
    name: "SrilankaSidebarMixin",
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            STUDY: 'kenya'
        };
    },
    computed: {},
    created: function () {},
    methods: {
        getAdverseEventsCount(){
            return HTTP.get('/srilanka/adverse_events/get_count');
        },
        getotherseriousadverseeventscount(){
            return HTTP.get('/srilanka/serious_adverse_events/get_count');
        },
    },
};
